import React from 'react'

import { Grid } from '@mui/material'
import { useParams } from 'react-router-dom'

import LoadingView from 'components/LoadingView'
import { useCampaignBanners } from 'hooks/useCampaignBanners'
import { BANNER_TYPES } from 'models/campaign-banners-model'

import CampaignBannersTable from './CampaignBannersTable'

type CampaignBannersProps = {
  customerId: number
}

const CampaignBanners = ({ customerId }: CampaignBannersProps) => {
  const { id } = useParams()
  const { data, isLoading, error } = useCampaignBanners(id)

  const banners = data ?? []
  const images = banners.filter((banner: any) => banner.type === BANNER_TYPES.image)
  const html5 = banners.filter((banner: any) => banner.type === BANNER_TYPES.html5)

  return (
    <LoadingView error={error ? 'Error occurred when loading banners data' : undefined} loading={isLoading}>
      <Grid container spacing={2}>
        <Grid size={{ sm: 12 }}>
          <CampaignBannersTable
            banners={images}
            customerId={customerId}
            id={id ?? ''}
            title="Image"
            type={BANNER_TYPES.image}
          />
        </Grid>
        <Grid size={{ sm: 12 }}>
          <CampaignBannersTable
            banners={html5}
            customerId={customerId}
            id={id ?? ''}
            title="HTML 5"
            type={BANNER_TYPES.html5}
          />
        </Grid>
      </Grid>
    </LoadingView>
  )
}

export default CampaignBanners
